import { render, staticRenderFns } from "./FormFB.vue?vue&type=template&id=7ed0e098&scoped=true&"
import script from "./FormFB.vue?vue&type=script&lang=js&"
export * from "./FormFB.vue?vue&type=script&lang=js&"
import style0 from "./FormFB.vue?vue&type=style&index=0&id=7ed0e098&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ed0e098",
  null
  
)

export default component.exports